import { assertUniqueName, clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getRegion } from './get-region';

/** `PUT /client/:cid/regions {id, name, hub_ids}` with the region's current `hub_ids`, so only the name changes. */
export const editRegion = async (region_id: string, name: string): Promise<any> => {
  const [region, regions] = await Promise.all([
    getRegion(region_id),
    lpRequest('GET', clientPath('/regions'))
  ]);
  assertUniqueName(regions || [], name, 'region', region_id);

  await lpRequest('PUT', clientPath('/regions'), {
    body: { id: region_id, name: name.trim(), hub_ids: region.hub_ids }
  });

  return getRegion(region_id);
};
